import { createFileRoute } from '@tanstack/react-router';
import { NotFoundComponent } from '@/components/NotFoundComponent.tsx';

// Catch-all under a space. Besides unknown pages, this lets old
// /$teamSlug/$spaceSlug/... URLs reach the space layout, which redirects them.
export const Route = createFileRoute('/$spaceSlug/$')({
  component: NotFoundComponent,
});
